import { BackendClubRepository } from '@/fairplayer/secondary/club/BackendClubRepository';
import { ClubSlug } from '@/fairplayer/domain/club/ClubSlug';
import { UploadRepository } from '@/fairplayer/domain/upload/UploadRepository';
import { S3Repository } from '@/fairplayer/secondary/upload/S3Repository';
import { PresignedUpload } from '@/fairplayer/domain/upload/PresignedUpload';
import { FileContentType } from '@/fairplayer/domain/upload/FileContentType';

export class FairplayerUploadRepository implements UploadRepository {
  constructor(
    private s3Repository: S3Repository,
    private backendClubRepository: BackendClubRepository
  ) {}

  createPresignedUpload(clubSlug: ClubSlug, contentType: FileContentType): Promise<PresignedUpload> {
    return this.backendClubRepository.createPresignedUpload(clubSlug, contentType);
  }

  uploadFileToStorage(file: File, presignedUrl: string): Promise<void> {
    return this.s3Repository.uploadFileToStorage(file, presignedUrl);
  }
}
